<template>
  <div class="top">
    <div class="cover" />
    <section :class="wrapperClass">
      <section class="desc all-centered">
        <span :class="fontTitle">
          Personalized Data-AI Skills Transformation
        </span>
        <span class="subtitle">
          Unlock your potential. Test. Assess. Progress.
        </span>
        <div v-if="$mq === 'desktop'" class="row">
          <div class="column">
            <div id="yellow-card" class="card">
              <div class="description-2 card-font1">FOR INDIVIDUALS</div>
              <div class="title-3">Personal <br />transformation</div>
              <div class="right-btn">
                <a
                  class="white-button-blue-border"
                  style="border: none"
                  href="/app/login/"
                  >Take the test</a
                >
              </div>
              <br />
            </div>
          </div>

          <div class="column">
            <div id="normal-card" class="card">
              <div class="description-2 card-font1">FOR ENTERPRISES</div>
              <div class="title-3">Organizational <br />transformation</div>
              <div class="right-btn">
                <a class="white-button-blue-border" href="https://workera.ai"
                  >Learn more</a
                >
              </div>
              <br />
            </div>
          </div>
        </div>
      </section>
      <div id="yellow-circle-1" v-if="$mq === 'desktop'" class="circle" />
      <div id="yellow-circle-2" v-if="$mq === 'desktop'" class="circle" />
      <div id="yellow-circle-3" v-if="$mq === 'desktop'" class="circle" />
      <div id="yellow-circle-4" v-if="$mq === 'desktop'" class="circle" />
      <div id="yellow-circle-5" v-if="$mq === 'desktop'" class="circle" />
      <div id="yellow-circle-6" v-if="$mq === 'desktop'" class="circle" />
    </section>

    <div v-if="$mq !== 'desktop'" :class="smallDevice">
      <div class="card-mobile">
        <div id="yellow-card" class="card">
          <div class="card-text">
            <div class="description-2 card-font-mobile-1">For individuals</div>
            <div class="title-3">Personal transformation</div>
          </div>
          <div class="right-btn">
            <a class="white-button-blue-border" @click="scroll_section()"
              >Learn more</a
            >
          </div>
        </div>
      </div>

      <div class="card-mobile mobile-bottom">
        <div class="card">
          <div class="card-text">
            <div class="description-2 card-font-mobile-1">For Enterprises</div>
            <div class="title-3">Organizational transformation</div>
          </div>
          <div class="right-btn">
            <a class="white-button-blue-border" href="https://workera.ai/"
              >Learn more</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    wrapperClass() {
      switch (this.$mq) {
        case 'desktop':
          return 'wrapper'
        case 'tablet':
          return 'wrapper tablet'
        default:
          return 'wrapper mobile'
      }
    },
    innerClass() {
      switch (this.$mq) {
        case 'desktop':
          return 'column--duo--equivalent'
        default:
          return 'single'
      }
    },
    fontTitle() {
      switch (this.$mq) {
        case 'desktop':
          return 'title-2'
        default:
          return 'mobile-font-title'
      }
    },
    smallDevice() {
      switch (this.$mq) {
        case 'tablet':
          return 'tablet'
        default:
          return 'mobile'
      }
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
/* general Style  */
.card {
  padding: 2rem 1rem 0 1rem;
  text-align: left;
  min-height: 100%;
  margin: auto;
  max-width: 26.25rem;
}
#yellow-card {
  background: $primary-yellow;
}

/*********************************************************************************** */
.top {
  .wrapper {
    margin-top: 10rem;
    &.tablet {
      .desc.all-centered {
        padding-left: 1.4rem;
        padding-right: 1.4rem;
      }
    }
    .title-2 {
      font-weight: 800;
      font-size: 80px;
      line-height: 77.66px;
      width: 100%;
    }
    .subtitle {
      font-family: Assistant;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 28px;
      letter-spacing: 0.0347222238779068px;
      text-align: center;
      margin-top: 42px;
    }
    .mobile-font-title {
      font-size: 40px;
      line-height: 40px;
      font-weight: 800;
    }
    .row {
      margin-left: auto;
      margin-right: auto;
      margin-top: 2rem !important;
      width: 100%;

      .column {
        width: 50%;
        display: block;
        min-height: 100%;

        .card {
          padding: 1.5rem;
          padding-bottom: 0 !important;

          .card-font1 {
            font-size: 18px;
            font-weight: 700;
            line-height: 23.54px;
            opacity: 0.6;
          }

          .right-btn {
            margin-right: auto;
          }

          .title-3 {
            margin-bottom: 1rem;
            margin-top: 1rem;
            font-size: 32px;
            line-height: 38.4px;
            font-weight: 700;
            letter-spacing: -1px;
          }
        }
      }
    }

    .row:after {
      content: '';
      display: table;
      clear: both;
    }
    #yellow-card {
      margin-right: 1rem;
    }
    #normal-card {
      margin-left: 1rem;
    }
  }
  /*********************TABLET********************* */
  .tablet {
    #normal-card {
      margin-top: 2rem;
    }
    .card-mobile {
      width: 90%;
      margin: auto;
      .card {
        flex-direction: row;
        .card-text {
          width: 60%;
        }
        .white-button-blue-border {
          width: 100%;
          display: block;
        }
        .title-3 {
          font-size: 24px;
          font-weight: 700;
          line-height: 28.8px;
          text-align: left;
          margin-bottom: 1rem;
          margin-top: 0.5rem;
        }
        .card-font-mobile-1 {
          font-size: 16px;
          font-weight: 700;
          line-height: 20.93px;
          opacity: 0.6;
          text-align: left;
        }
        .right-btn {
          margin-right: auto;
          margin-left: auto;
          margin-bottom: 2rem;
          align-items: center;
          margin-top: 2rem;
          .white-button-blue-border {
            font-size: 16px;
            font-weight: 700;
            line-height: 20.93px;
          }
          a {
            margin-top: 0;
            margin-bottom: 0;
          }
        }
      }
      &.mobile-bottom {
        margin-top: 2rem;
      }
    }
  }
  //*****FOR MOBILE******** */
  .mobile {
    #normal-card {
      margin-top: 1rem;
    }
    .card-mobile {
      width: 90%;
      margin: auto;
      .white-button-blue-border {
        width: 100%;
        display: block;
      }
      .title-3 {
        font-size: 24px;
        font-weight: 700;
        line-height: 28.8px;
        text-align: center;
        margin-bottom: 1rem;
        margin-top: 1rem;
      }
      .card-font-mobile-1 {
        font-size: 16px;
        font-weight: 700;
        line-height: 20.93px;
        opacity: 0.6;
        text-align: center;
      }
      .right-btn {
        margin-right: auto;
        margin-left: auto;
        margin-bottom: 1rem;
        align-items: center;
        .white-button-blue-border {
          font-size: 16px;
          font-weight: 700;
          line-height: 20.93px;
        }
      }
      &.mobile-bottom {
        margin-top: 1rem;
      }
    }
  }

  position: relative;

  %yellow-circle {
    background: #f9cd46;
    position: absolute;
    border-radius: 50%;
    opacity: 0.2;
  }

  #yellow-circle-1 {
    @extend %yellow-circle;
    width: 179px;
    height: 179px;
    left: -300px;
    top: -100px;
  }

  #yellow-circle-2 {
    @extend %yellow-circle;
    width: 100px;
    height: 100px;
    left: 10px;
    top: -103px;
  }

  #yellow-circle-3 {
    @extend %yellow-circle;
    width: 100px;
    height: 100px;
    right: -30px;
    top: -143px;
  }

  #yellow-circle-4 {
    @extend %yellow-circle;
    width: 137px;
    height: 137px;
    right: 30px;
    top: 60px;
  }

  #yellow-circle-5 {
    @extend %yellow-circle;
    width: 100px;
    height: 100px;
    left: -400px;
    top: 303px;
  }

  #yellow-circle-6 {
    @extend %yellow-circle;
    width: 137px;
    height: 137px;
    right: -400px;
    top: 153px;
  }

  .unlock-font {
    font-size: 24px;
    line-height: 28.39px;
    font-weight: 600;
  }
}
.circle {
  z-index: -100;
}
</style>
